document.body.classList.add('product');

document.addEventListener("DOMContentLoaded", () => {
  const default_lens_color = document.querySelector('[data-rx-prop][name="lens-color"]:checked');
  const rx_button = document.getElementById("btnConfigureType");
  const params = new URLSearchParams(window.location.search);

  setTimeout(() => {
        if (document.querySelector('body').classList.contains('loop-returns-activated')) {
            window.location.href = 'https://shadyrays.com';
        }
  }, 500);
  /*
  if (params.has('reloadrx')) {
    setTimeout(() => {
      window.location.href = window.location.pathname + "?finalreload=reload";
    }, 4000);
  }

  if (params.has('finalreload')) {
  */
  if (params.has('reloadrx')) {
    const url = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, url);

    //document.querySelector('.js-cart-drawer').open();
    setTimeout(() => {
      const cartForm = document.querySelector('cart-form');

      if (cartForm) {
        cartForm.refresh();
      }
      
      document.dispatchEvent(
        new CustomEvent('on:cart:after-merge', { bubbles: true, cancelable: false })
      );
      
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
        bubbles: true
      }));

      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    }, 1000);
  }
  
  BOLD.common.settings.log_events = true;  
  BOLD.options.app.on('option_changed', function (data) {    
    document.querySelectorAll('.money, .info-badge').forEach(function (element) {
      element.style.visibility = 'visible';
    });

    setTimeout(function () {
      document.querySelectorAll('.money, .info-badge').forEach(function (element) {
        element.style.visibility = 'visible';
      });
    }, 2000);
  });

  initRxAccordion();
  toggleBlueLight();
  calculateTotal();

  if (default_lens_color) {
    lensColorChange(default_lens_color);
    swapImages(default_lens_color.value);
  }

  rx_button.addEventListener("click", toggleRXButton);

  document.querySelectorAll('[data-rx-prop]').forEach(el => {
    changeOptions(el);
  });
  document.querySelectorAll('[data-rx-prop-check]').forEach(el => {
    changeOptions(el);
  });

  document.getElementById('btnUploadPrescription').addEventListener('click', function () {
    // Trigger the file input click event
    document.querySelector('input[type="file"][name="properties[Prescription]"]').click();
    
    document.querySelector('input[name="properties[Prescription]"]').addEventListener('change', function () {
      const ask_email_later = document.querySelector('input[name="properties[Ask Via Email]"][value="--"]');
      let file = document.querySelector('[name="properties[Prescription]"]').files[0].name;

      ask_email_later.click();
      document.getElementById('btnAskMeLater').classList.remove('error');
      document.getElementById('btnAskMeLater').classList.remove('selected');
      document.getElementById('infoFileName').textContent = file;
      document.getElementById('infoFileName').style.display = 'block';
      document.getElementById('btnUploadPrescription').classList.remove('error');
      document.getElementById('btnUploadPrescription').classList.add('selected');
      document.getElementById('infoPDMeasurement').style.display = 'block';
    });
  });

  document.getElementById('btnAskMeLater').addEventListener('click', function () {
    const ask_email_later = document.querySelector('input[name="properties[Ask Via Email]"][value="Yes"]');
    ask_email_later.click();

    document.getElementById('btnAskMeLater').classList.add('selected');
    document.getElementById('btnUploadPrescription').classList.remove('selected');
    document.getElementById('btnUploadPrescription').classList.remove('error');
    document.getElementById('btnAskMeLater').classList.remove('error');

    document.getElementById('infoPDMeasurement').style.display = 'none';
    document.getElementById('infoFileName').textContent = "";
    document.querySelector('input[type="file"][name="properties[Prescription]"]').value = "";
    document.getElementById('btnUploadPrescription').classList.remove('selected');
    document.getElementById('btnUploadPrescription').classList.remove('error');

  });

});

function scrollToImage() {
  const img_container = document.querySelector('.main-image');
  const offset = img_container.getBoundingClientRect().top + window.scrollY - 50;
  window.scrollTo({ top: offset, behavior: 'smooth' });
  return false;
}

function changeOptions(el) {
  const container = document.querySelector('.product-rx-attributes-accordion');
  el.addEventListener('change', () => {
    if (el.name === 'lens-material') {
      lensMaterialChange(el);
    }

    if (el.name === 'lens-type') {
      lensTypeChange(el);
      const selected_color_dot = container.querySelector(`input[name="lens-type"][value="${el.dataset.defaultColor}"]`);
      if (selected_color_dot)
        selected_color_dot.checked=true;
      swapImages(el.dataset.defaultColor);
    }
    /*
    if(el.name === 'photolens-color') {
      const photo_chromic = container.querySelector(`input[name="${el.dataset.rxProp}"][value="${el.value}"]`);
      if (photo_chromic) 
        photo_chromic.click();
    }
    */

    if (el.name === 'lens-color') {
      lensColorChange(el);
      swapImages(el.value);
    }
    
    toggleAntiReflecting();
    toggleBlueLight();
    calculateTotal();
  });
}

// Calculate Total
function calculateTotal() {
  const rx_frame_price = document.querySelector('#product_frame_price').dataset.rxPrice;
  const blue_light = document.querySelector('[name="blue-light"]');
  const parent_element = document.querySelector('.js-product');
  const price_section = parent_element.querySelectorAll('[data-target="price-element"]');
  const currentCurrency = Shopify.currency.active;
  const currencySymbols = {
          USD: "$",
          EUR: "€",
          GBP: "£",
          CAD: "CAD$",
          AUD: "AUD$",
      };
  const currencySymbol = currencySymbols[currentCurrency] || "$";

  let total = 0;
  //console.clear();
  //console.log('Frame price: ', rx_frame_price);

  total += parseFloat(rx_frame_price);

  if (blue_light) {
    if(blue_light.checked)
      total += parseFloat(blue_light.dataset.rxPrice);
  }

  document.querySelectorAll('[data-rx-prop]:checked').forEach(el => {
    if (el.dataset.rxPrice) {
      //console.log(`Option price: ${el.dataset.rxProp} ${el.dataset.rxPrice}`);
      total += parseFloat(el.dataset.rxPrice);
    }
  });
  
  formattedPrice = currencySymbol + (parseFloat(total)/100).toFixed(2);

  //console.log(price_section);
  //console.log(formattedPrice);

  price_section.forEach(price => {
    price.innerHTML = formattedPrice;
  });
  
  MarkdownPricePro.run();
  //console.log("Total: ", total);
}

function lensMaterialChange(element) {
  const non_high_index = document.querySelectorAll('.non-high-index167');
  if (element.value === 'High Index 1.67') {
    const restrictedColors = ['LavenderRose', 'Royal', 'Calimesa', 'Infrared', 'Glacier'];

    restrictedColors.forEach(color => {
      if (document.querySelector(`[name="lens-color"][value="${color}"]`).checked) {
        document.querySelector('[name="lens-color"][value="Grey"]').click();
      }
    });

    non_high_index.forEach(el => (el.style.display = 'none'));
  } else {
    non_high_index.forEach(el => (el.style.display = 'block'));
  }
}

function lensTypeChange(element) {
  if (element.value === 'Non-Polarized') {
    document.querySelectorAll('.polarized-only').forEach(function (el) {
      el.style.display = 'none';
    });
    document.querySelector('[name="lens-color"][value="Grey"]').click();
  } else {
    document.querySelectorAll('.polarized-only').forEach(function (el) {
      el.style.display = 'block';
    });
    if (document.querySelector('[name="lens-color"]:checked') && document.querySelector('[name="lens-color"]:checked').value === 'Shooter') {
      document.querySelector('[name="lens-color"][value="Amber"]').click();
    }
  }

  if (element.value === 'Photochromic') {
    let selectedColor = document.getElementById('photoChromicColor').getAttribute('data-selected');
    document.querySelector('[name="photolens-color"][value="' + selectedColor + '"]').click();
    document.querySelector('[name="lens-color"][value="--"]').click();
    document.querySelector('.window-photochromatic').style.display = 'block';
  } else if (element.value === 'Clear') {
    document.querySelector('[name="photolens-color"][value="--"]').click();
    document.querySelector('[name="lens-color"][value="--"]').click();
    document.querySelector('.window-photochromatic').style.display = 'block';
  } else {
    document.querySelector('[name="photolens-color"][value="--"]').click();
    document.querySelector('.window-photochromatic').style.display = 'none';
  }
}

function lensColorChange(element) {
  const infoLens = document.getElementById('infoLensColorName');
  const priceLens = document.getElementById('infoLensColorPrice');
  const price_section = document.querySelectorAll('.price__current .money');
  const currentCurrency = Shopify.currency.active;
  const currencySymbols = {
          USD: "$",
          EUR: "€",
          GBP: "£",
          CAD: "CAD$",
          AUD: "AUD$",
      };
  const currencySymbol = currencySymbols[currentCurrency] || "$";
  
  toggleAntiReflecting();

  if (infoLens) {
    infoLens.textContent = element.value;
  }

  if (priceLens) {
    priceLens.textContent = '+' + currencySymbol + (parseFloat(element.dataset.rxPrice)/100).toFixed(2);;
  }
}

function toggleAntiReflecting() {
  const anti_reflecting_lbl = document.getElementById('optAntiReflectingCoating');
  const anti_reflecting_chk = anti_reflecting_lbl.querySelector('input[name="anti-reflect"]');
  const lens_color = document.querySelector('[data-rx-prop][name="lens-color"]:checked');
  const rx_button = document.getElementById('btnConfigureType');
  const mirror_lens = document.querySelector('.text-mirror-lens');

  const lens_colors = [
      'Amber',
      'Shooter',
      'Grey'
    ];
  if (rx_button.textContent === 'Configure as Sunglasses') {
    anti_reflecting_lbl.style.display = 'flex';
  } else {
    if(lens_color) {
      if(lens_colors.includes(lens_color.value)) {
        anti_reflecting_lbl.style.display = 'flex';
        mirror_lens.style.display = 'none';
      } else {
        anti_reflecting_chk.checked = false;
        anti_reflecting_lbl.style.display = 'none';
        mirror_lens.style.display = 'block';
      }
    }
  }
}

function toggleBlueLight() {
  const blue_light_lbl = document.getElementById('optBlueLightProtection');
  if (blue_light_lbl) {
    const lensMaterial = document.querySelector('[name="lens-material"]:checked');
    const lensType = document.querySelector('[name="lens-type"]:checked');
    const rx_button = document.getElementById('btnConfigureType');
    const blue_light_chk = blue_light_lbl.querySelector('input[name="blue-light"]');

    if(lensMaterial && lensType) {
      if((lensMaterial.value === 'Polycarbonate' || lensMaterial.value === 'CR39' || lensMaterial.value === 'High Index 1.67') && lensType.value === 'Clear' && rx_button.textContent === 'Configure as Sunglasses') {
          blue_light_lbl.style.display = 'flex';
      } else {
        if (blue_light_chk) {
          blue_light_chk.checked = false;
          blue_light_lbl.style.display = 'none';
        }
      }
    } 
  }
}

function toggleRXButton() {
  const rx_button = document.getElementById('btnConfigureType');
  const lens_type_container = document.getElementById('lensTypeDiv');
  const color_lens_type_container = document.getElementById('lenseColorDiv');

  if (rx_button.textContent === "Configure as Sunglasses") {
    rx_button.textContent = "Configure as Clear Lenses"
    lens_type_container.style.display="none";
    color_lens_type_container.style.display="block";
    document.querySelector('input[name="lens-type"][value="Polarized"]').click();
    document.querySelector('[name="lens-color"][value="Grey"]').click();
  } else {
    rx_button.textContent = "Configure as Sunglasses";
    lens_type_container.style.display="block";
    color_lens_type_container.style.display="none";
    document.querySelector('input[name="lens-type"][value="Clear"]').click();
    //document.querySelector('[name="lens-color"][value="Grey"]').click();
  }
  toggleAntiReflecting();
  toggleBlueLight();
  calculateTotal();
}

// Initialize RX accordion
function initRxAccordion() {
  document.querySelectorAll('.product-rx-attributes-accordion').forEach(accordion => {
    accordion.querySelectorAll('.accordion-head').forEach(head => {
      head.addEventListener('click', () => {
        const isOpen = head.nextElementSibling.classList.contains('open-body');

        document.querySelectorAll('.accordion-head').forEach(h => h.classList.remove('open'));
        document.querySelectorAll('.accordion-body').forEach(b => b.classList.remove('open-body'));

        if (!isOpen) {
          head.classList.add('open');
          head.nextElementSibling.classList.add('open-body');
          window.scrollTo({ top: head.nextElementSibling.offsetTop - 160, behavior: 'smooth' });
        } else {
          window.scrollTo({ top: accordion.querySelector('.accordion-head h2').offsetTop - 160, behavior: 'smooth' });
        }
      });
    });
  });
}

function swapImages(color='') {
    if (color === '') {
      // for (let i = 0; i < rxPrescription.defaultImages.length; i++) {
      //   appendImage(rxPrescription.defaultImages[i]);
      // }
      for (let i = 1; i <= Math.min(2, rxPrescription.defaultImages.length); i++) {
          let imagePath = rxPrescription.defaultImages[i-1];
          appendImage(imagePath, i);
      }
      //rxPrescription.defaultImages.forEach((image) => appendImage(image.url));
    } else {
        let folder = rxPrescription.rxsunglasses ? 'sunglasses' : 'eyeglasses';
        const base = `https://shady-rays.s3.us-east-2.amazonaws.com/assets/${folder}/${rxPrescription.sku}/${rxPrescription.sku}`;
        if (color === 'Bronze') {
          color = 'Gold';
        }
        for (let i = 1; i <= Math.min(2, rxPrescription.defaultImages.length); i++) {
            let imagePath = `${base}-${i === 1 ? 'R' : 'F'}_${color}.jpg`;
            appendImage(imagePath, i);
        }
    }
}

function appendImage(image_src, index) {
  const sliderGrid = document.querySelector('.main-image .slider__grid');
  const thumbnailSliderGrid = document.querySelector('.thumbnails .slider__grid');

  // Check if the slider grid exists
  if (sliderGrid) {
    // Select all image elements within the slider grid
    const images = sliderGrid.querySelectorAll('img');
    const thumbnailImages = thumbnailSliderGrid.querySelectorAll('img');

    // Define new src and srcset URLs dynamically (replace with your logic)
    const newSrcSet = `
        ${image_src}?width=340 340w,
        ${image_src}?width=480 480w,
        ${image_src}?width=740 740w,
        ${image_src}?width=980 980w
      `;
    const thumbnailNewSrcSet = `
        ${image_src}?width=65 65w,
        ${image_src}?width=130 130w
      `;

    // Update the src and srcset attributes
    if (index) {
      images[index - 1].src = image_src;
      images[index - 1].srcset = newSrcSet;

      thumbnailImages[index - 1].src = image_src;
      thumbnailImages[index - 1].srcset = thumbnailNewSrcSet;
    } else {
      images.forEach((image, index) => {
        image.src = image_src;
        image.srcset = newSrcSet;
        thumbnailImages[index].src = image_src;
        thumbnailImages[index].srcset = thumbnailNewSrcSet;

      })
    }
  }
}

// Review Order
document.addEventListener("DOMContentLoaded", () => {
  const prescriptionModal = document.querySelector(".product-rx-preview-overlay");
  const closeButton = document.querySelector(".close");
  const reviewOrderButton = document.querySelector("#reviewOrderButton");

  const toggleVisibility = (element, show) => {
    if (element) {
      element.style.display = show ? "block" : "none";
    }
  };

  const getCheckedValue = (name) => {
    const input = document.querySelector(`input[name="${name}"]:checked`);
    return input ? input.value : "";
  };

  if (closeButton) {
    closeButton.addEventListener("click", (e) => {
      e.preventDefault();
      prescriptionModal?.classList.add("hidden");
      document.querySelector('body').classList.remove("rx-modal_open")
    });
  }

  document.querySelector('[name="pd-measurement"]').addEventListener("input", function() {
    const btn_upload = document.getElementById('btnUploadPrescription');
    this.classList.remove('error');
    if(this.value == '' && !btn_upload.classList.contains('selected')) {
      this.classList.add('error');
    }
  });

  if (reviewOrderButton) {
    reviewOrderButton.addEventListener("click", (e) => {
      e.preventDefault();
      
      // Update preview content
      const pColorLens = getCheckedValue("lens-color");
      let show_modal = true;
      const btn_upload = document.getElementById('btnUploadPrescription');
      const pdp_measurement = document.querySelector('[name="pd-measurement"]');
      const antiReflectInput = document.querySelector("input[name='anti-reflect']");
      const antiReflectChecked = antiReflectInput?.checked && antiReflectInput.value === "Yes";

      document.querySelector(".prev-rx-prescription-type").textContent = getCheckedValue("prescription-type");
      document.querySelector(".prev-rx-lens-color").textContent = pColorLens;
      document.querySelector(".prev-rx-photolens-color").textContent = getCheckedValue("photolens-color");
      document.querySelector(".prev-rx-lens-material").textContent = getCheckedValue("lens-material");
      document.querySelector(".prev-rx-anti-reflective").textContent = antiReflectChecked ? "Yes" : "No";
      document.querySelector(".prev-rx-lens-type").textContent = getCheckedValue("lens-type");

      // Handle conditional displays
      toggleVisibility(document.querySelector(".prev-rx-photo-prescription"), document.querySelector("#btnUploadPrescription")?.classList.contains("selected"));
      toggleVisibility(document.querySelector(".prev-rx-ask-via-email"), document.querySelector("#btnAskMeLater")?.classList.contains("selected"));
      toggleVisibility(document.querySelector(".prev-rx-use-past-information"), document.querySelector("#btnUsePastInfo")?.classList.contains("selected"));

      // Handle popup anti-reflective display
      const popupAntiReflective = document.querySelector(".popup-anti-reflective");
      const showAntiReflective = ["Amber", "Grey", "Shooter"].includes(pColorLens) || antiReflectChecked;
      toggleVisibility(popupAntiReflective, showAntiReflective);

      // Update image and price
      const thumbnail = document.querySelector(".slider__grid .slider__item:last-of-type .theme-img");
      const price = document.querySelector(".span.money");

      if (thumbnail) {
        document.querySelector(".product-rx-preview-img").src = thumbnail.src;
      }

      if (price) {
        document.querySelector(".product-rx-preview-price").textContent = price.textContent;
      }

      if(btn_upload?.classList.contains("selected")) {
        if(pdp_measurement.value == '') {
          pdp_measurement.classList.add('error');
          pdp_measurement.focus();
          window.alert('Please provide your PD measurements');
          show_modal = false;
        }
      }
      
      // Show the modal
      if (show_modal) {
        prescriptionModal?.classList.remove("hidden");
        document.querySelector('body').classList.add("rx-modal_open");
      }
      
    });
  }

  class RxPrescription {

    constructor() {
      this.selectors = {
        prescriptionType: '[name="prescription-type"]',
        lensMaterial: '[name="lens-material"]',
        lensType: '[name="lens-type"]',
        lensColor: '[name="lens-color"]',
        antiReflect: '[name="anti-reflect"]',
        blueLight: '[name="blue-light"]',
        pdMeasurement: '[name="pd-measurement"]',
        askViaEmail: '#btnAskMeLater',
        uploadPrescription: '#btnUploadPrescription',
        usePastInfo: '#btnUsePastInfo',
        reviewOrder: '#reviewOrderButton',
        close: '.close',
        form: 'form[data-form="rx"]',
      };

      this.addToCartForm = document.querySelector(this.selectors.form);
      this.addToCartBtn = this.addToCartForm.querySelector('button[type="submit"]:not(.bold_hidden)'); 
      this.rxElements = {
        btnAsk: document.getElementById('btnAskMeLater'),
        btnUpload: document.getElementById('btnUploadPrescription'),
        isBlueLight: document.querySelector('[name="blue-light"]'),
        lensType: document.querySelector('[name="lens-type"]:checked'),
        prescriptionModal: document.querySelector(".product-rx-preview-overlay"),
        measurement: document.querySelector('textarea[name="pd-measurement"]')
      }

    }

    init() {
      this.addEventListeners();
    }

    addEventListeners() {            
      this.addToCartForm.addEventListener("submit", this.handleAddCart.bind(this));
    }

    disabledAddToCart(addToCartBtn){
      addToCartBtn.setAttribute('aria-disabled', 'true');
      addToCartBtn.classList.add('is-loading');
    }

    reEnableAddToCart(addToCartBtn){
      addToCartBtn.classList.add('is-success');
      addToCartBtn.removeAttribute('aria-disabled');
      setTimeout(() => {
        addToCartBtn.classList.remove('is-loading');
        addToCartBtn.classList.remove('is-success');
      }, 2000);
    }
    
    handleAddCart(e) {
      e.preventDefault();
      const addToCartBtn = this.addToCartForm.querySelector('button.bold_clone'); 
      this.disabledAddToCart(addToCartBtn)
      
      if (!this.validateForm()) {
        this.reEnableAddToCart(addToCartBtn)
        return;
      }

      const { btnUpload, btnAsk, measurement, prescriptionModal, isBlueLight, lensType} = this.rxElements;
      const close = prescriptionModal.querySelector(".close");

      if (btnUpload.classList.contains("selected") && measurement) {
        if (document.querySelector('textarea[name="properties[PD Measurement]"]'))
          document.querySelector('textarea[name="properties[PD Measurement]"]').value = measurement.value;
      }

      if (isBlueLight) {
        if(isBlueLight.checked){
          if (document.querySelector('input[name="properties[Blue Light Protection]"][value="Yes"]'))
            document.querySelector('input[name="properties[Blue Light Protection]"][value="Yes"]').click();
        }
      } else {
        if (document.querySelector('input[name="properties[Blue Light Protection]"][value="--"]'))
          document.querySelector('input[name="properties[Blue Light Protection]"][value="--"]').click();
      }

      document.querySelectorAll('[data-rx-prop]:checked').forEach(el => {
        const propertyInput = document.querySelector(`input[name="${el.dataset.rxProp}"]`);
        if (propertyInput) {
          document.querySelector(`input[name="${el.dataset.rxProp}"][value="${el.value}"]`).click();
        }
      });

      if(lensType.value === 'Clear' || lensType.value === 'Photochromic') {
        document.querySelector('input[name="properties[Lens Color]"][value="--"]').click();
      }

      let formData = new FormData(this.addToCartForm);
      var self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        setTimeout(() => {
          prescriptionModal?.classList.add("hidden");
          self.reEnableAddToCart(addToCartBtn);
          console.log("prescription-product");
          const item = document.querySelector('.product-priority-vip-processing');
          if (item){
            item.querySelector('.cart-item__remove').click();
          }
          //window.location.reload();
           document.dispatchEvent(
            new CustomEvent('theme:open-cart-drawer', { bubbles: true, cancelable: false })
          );
          window.location.href = window.location.pathname + "?reloadrx=reload";
        }, 7000);
      })
      .catch(error => {
        self.reEnableAddToCart(addToCartBtn)
        console.log("Error adding product to cart.");
      });
    }

    validateForm() {
      const { btnUpload, btnAsk, measurement, prescriptionModal, isBlueLight, lensType} = this.rxElements;

      if (btnUpload.classList.contains("selected") || btnAsk.classList.contains("selected")) {
        return true;
      }

      const accPrescription = document.getElementById('provide-prescription-acc-item');
      accPrescription.querySelector('.accordion-head').classList.add('open');
      accPrescription.querySelector('.accordion-body').classList.add('open-body');

      if(prescriptionModal) {
        prescriptionModal?.classList.add("hidden");
        document.querySelector('body').classList.remove("rx-modal_open");
        window.alert('Please provide your prescription');
      }
      
      if(btnUpload) {
        btnUpload.classList.add("error");
      }

      if(btnAsk) {
        btnAsk.classList.add("error");
      }
      return false;
    }

  }
  const rxPrescription = new RxPrescription();
  rxPrescription.init();
});